import { motion } from "framer-motion";

export default function PullQuote() {
  return (
    <section aria-label="Signature perspective" className="relative border-b border-surface-2 overflow-hidden bg-[#0b1a30]">
      <div className="mx-auto max-w-[1440px] px-6 md:px-16 py-32 md:py-56 relative">
        <div
          aria-hidden
          className="pointer-events-none absolute -left-10 top-6 font-serif-display text-[28vw] leading-none text-brass/[0.06] select-none italic"
        >
          &ldquo;
        </div>

        <div className="relative grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-2 text-[11px] uppercase tracking-[0.28em] text-brass">
            <span className="tabular">09·</span><span className="ml-3">In Practice</span>
          </div>
          <div className="col-span-12 md:col-span-10">
            <motion.blockquote
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 1.2, ease: [0.22, 1, 0.36, 1] }}
              className="font-serif-display text-ivory font-light leading-[1.02] tracking-[-0.02em] text-4xl md:text-6xl lg:text-7xl"
            >
              A board that reads the plan carefully <span className="italic text-brass">never has to explain the variance.</span>{" "}
              <span className="text-mutedfg italic">That is the whole practice —</span> written in cadence, not commentary.
            </motion.blockquote>

            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 1, delay: 0.4 }}
              className="mt-14 flex items-center gap-6"
            >
              <span className="h-px w-16 bg-brass" />
              <div>
                <div className="font-serif-display italic text-ivory text-xl">Asad Hatimi</div>
                <div className="mt-1 text-[11px] uppercase tracking-[0.28em] text-mutedfg">
                  Enterprise Program Leader · Board Practice
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
}
